import homeStyles from "@/data/home-page-styles.json";
import serviceStyles from "@/data/service-styles.json";
import secondaryStyles from "@/data/secondary-styles.json";
import specialistShared from "@/data/secondary-service-styles.json";
import specialistStyles from "@/data/service-subpage-styles.json";
import coreStyles from "@/data/core-page-styles.json";
import webDesign from "@/data/service-hub-web-design-styles.json";
import seo from "@/data/service-hub-seo-styles.json";
import leadGen from "@/data/service-hub-lead-gen-styles.json";
import sem from "@/data/service-hub-sem-styles.json";
import aiAutomation from "@/data/service-hub-ai-automation-styles.json";
import aiVisibility from "@/data/service-hub-ai-visibility-styles.json";
import { parseLocaleFromPathname, resolveMarketingRoute } from "./i18n/paths";
import { getMarketSubpageImplementation } from "./i18n/market-pages";

const HUB_STYLES: Record<string, { href: string }> = {
  "web-design": webDesign, seo, "lead-gen": leadGen, sem,
  "ai-automation": aiAutomation, "ai-visibility": aiVisibility,
};

/** Shared by the initial HTML head and client navigation; React deduplicates these resources. */
export function getRouteStyles(pathname: string): { href: string; precedence: string }[] {
  if (pathname === "/dev" || pathname.startsWith("/dev/")) return [];
  const { locale, pathWithoutLocale } = parseLocaleFromPathname(pathname);
  if (pathWithoutLocale === "/") return [{ href: homeStyles.href, precedence: "home-page" }];
  const route = resolveMarketingRoute(pathWithoutLocale, locale ?? "en");
  // City pages are built from the webbyrå hub components, ad landing pages from the AI automation hub.
  const hub = route?.kind === "service" ? HUB_STYLES[route.serviceTag]
    : route?.kind === "local-landing" ? HUB_STYLES["web-design"]
    : route?.kind === "campaign-landing" ? HUB_STYLES["ai-automation"]
    : undefined;
  if (hub) return [{ href: hub.href, precedence: "service-hub" }];
  const coreKey = route?.kind === "blog-category" || route?.kind === "blog-post" ? "blog" : route?.kind;
  const core = coreKey ? (coreStyles as Record<string, { href: string }>)[coreKey] : undefined;
  if (core) return [{ href: core.href, precedence: "core-page" }];
  if (route?.kind === "service-subpage") {
    const implementation = getMarketSubpageImplementation(locale ?? "en", route.serviceTag, route.subKey);
    const specialist = (specialistStyles as Record<string, { href: string }>)[`${route.serviceTag}:${implementation}`];
    if (specialist) return [
      { href: specialistShared.href, precedence: "secondary-service" },
      { href: specialist.href, precedence: "service-subpage" },
    ];
  }
  const styles = [{ href: secondaryStyles.href, precedence: "secondary-pages" }];
  if (route?.kind === "services" || route?.kind === "service-subpage") {
    styles.push({ href: serviceStyles.href, precedence: "service-pages" });
  }
  return styles;
}
